export default __webpack_public_path__ + "static/media/lembas.b9efe43f.png";